package com.macrofocus.eflux.animation

import com.macrofocus.common.crossplatform.Timer
import com.macrofocus.eflux.ui.react.useInterval
import korlibs.time.DateTime
import korlibs.time.millisecondsLong
import react.useState

fun timeline(init: Timeline.() -> Unit) : Timeline {
    val timeline = Timeline()
    timeline.init()
    return timeline
}

class Timeline {
    val animations = ArrayList<Animation>()

    val react = false

    var started = false
    var timer: Timer? = null

    fun parallel(init: ParallelAnimation.() -> Unit) : ParallelAnimation {
        val parallelAnimation = ParallelAnimation()
        parallelAnimation.init()
        addAnimation(parallelAnimation)
        return parallelAnimation
    }

    fun addAnimation(animation: Animation) {
        animations.add(animation)
    }

    fun stop() {
        timer?.cancel()
        animations.clear()
    }

    fun start(onFinish: (() -> Unit)? = null) {
        val animationsIterator = animations.iterator()
        var animation = animationsIterator.next()
        var startTime = DateTime.now()
        animation.start()

        if(react) {
            val (delay, setDelay) = useState<Int?>(1000 / 60)

            useInterval({
                val duration = animation.duration
                val elapsedTime = (DateTime.now() - startTime).millisecondsLong

                animation.tick(elapsedTime)

                if (elapsedTime >= duration) {
                    if (animationsIterator.hasNext()) {
                        animation = animationsIterator.next()
                        startTime = DateTime.now()
                        animation.start()
                    } else {
//                        cancel()
                        setDelay(null)
                        println("Timer cancelled...")
                        onFinish?.invoke()
                    }
                }
            }, delay)
        } else {
            if(!started) {
                timer = object : Timer() {
                    override fun run() {
                        val duration = animation.duration
                        val elapsedTime = (DateTime.now() - startTime).millisecondsLong

                        animation.tick(elapsedTime)

                        if (elapsedTime >= duration) {
                            if (animationsIterator.hasNext()) {
                                animation = animationsIterator.next()
                                startTime = DateTime.now()
                                animation.start()
                            } else {
                                cancel()
                                println("Timer cancelled...")
                                onFinish?.invoke()
                            }
                        }
                    }
                }
                timer?.scheduleRepeating(1000 / 60)
                started = true
            }
        }
    }
}